import React, { Component } from "react";
import { useNavigate } from "react-router-dom";
// Wrapper to pass navigate() into the class component
function withNavigation(ComponentWithNav) {
  return function WrappedComponent(props) {
    const navigate = useNavigate();
    return <ComponentWithNav {...props} navigate={navigate} />;
  };
}
class Commonalert extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  popupClose() {
    var elems = document.getElementsByClassName("common_alert_popup");
    for (var i = 0; i < elems.length; i += 1) {
      elems[i].style.display = "none";
    }
    // Redirect only when OK is clicked and redirectTo prop exists
    if (this.props.redirectTo) {
      // If redirectTo is an object, use navigate with state
      if (
        typeof this.props.redirectTo === "object" &&
        this.props.redirectTo.path
      ) {
        this.props.navigate(this.props.redirectTo.path, {
          state: this.props.redirectTo.state,
        });
      } else {
        // Otherwise, fall back to normal URL redirect
        this.props.navigate(this.props.redirectTo);
      }
      return;
    }
    var loc = window.location.pathname;
    if (window.location.pathname === "/social-links") {
      window.location.reload();
    }
    if (window.location.pathname === "/changepassword") {
      window.location.reload();
    }
    if (window.location.pathname === "/holiday/add/") {
      window.location.href = "/holiday";
    }
    if (window.location.pathname === "/freeproducts/addfreeproducts") {
      window.location.href = "/freeproducts";
    }
    if (
      window.location.pathname ===
      `/freeproducts/editfreeproducts/${loc.split("/").at(-1)}`
    ) {
      window.location.href = "/freeproducts";
    }
    if (
      window.location.pathname === "/ingredients/add/" ||
      window.location.pathname === `/ingredients/edit/${loc.split("/").at(-1)}`
    ) {
      window.location.href = "/ingredients";
    }
    if (
      window.location.pathname === "/allergens/add/" ||
      window.location.pathname === `/allergens/edit/${loc.split("/").at(-1)}`
    ) {
      window.location.href = "/allergens";
    }
    if (
      window.location.pathname === `/master-entry/${loc.split("/").at(-1)}` ||
      window.location.pathname === `/master-entry/add/${loc.split("/").at(-1)}`
    ) {
      window.location.href = `/master-entry/${loc.split("/").at(-1)}`;
    }
    if (
      window.location.pathname ===
      `/master-entry/edit/${loc.split("/").at(-2)}/${loc.split("/").at(-1)}`
    ) {
      window.location.href = `/master-entry/${loc.split("/").at(-2)}`;
    }

    if (
      window.location.pathname === `/role/addRoles/` ||
      window.location.pathname === `/role/editRoles/${loc.split("/").at(-1)}`
    ) {
      window.location.href = `/role`;
    }
    if (window.location.pathname === "/products") {
      window.location.reload();
    }
    if (window.location.pathname === "/account/adduser") {
      window.location.href = `/account`;
    }
    if (window.location.pathname === "/account") {
      window.location.reload();
    }
    if (
      window.location.pathname ===
      `/resetpassword/${loc.split("/").at(-2)}/${loc.split("/").at(-1)}`
    ) {
      window.location.href = "/";
    }
    if (
      window.location.pathname === "/freesample/freecode/add/" ||
      window.location.pathname ===
        `/freesample/freecode/edit/${loc.split("/").at(-1)}`
    ) {
      window.location.href = "/freesample/freecode";
    }
    if (
      window.location.pathname === "/email-configuration" ||
      window.location.pathname === "/email-configuration/add" ||
      window.location.pathname === "/email-configuration/edit"
    ) {
      window.location.href = "/email-configuration";
    }
    if (window.location.pathname === "/email-campaign") {
      window.location.href = "/email-campaign";
    }
  }

  render() {
    var elems = document.getElementsByClassName("common_alert_popup");
    for (var i = 0; i < elems.length; i += 1) {
      elems[i].style.display = "block";
    }
    return (
      <>
        {" "}
        {
          <div
            className="custom-alert-pop common_alert_popup"
            style={{ display: "block" }}
          >
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>{this.props.title}</h4>
                </div>
                <div className="custom-alert-body">
                  <p>{this.props.message}</p>

                  <div className="alert-buttons">
                    {/* <a
                      onClick={this.popupClose.bind(this)}
                      className="popup-alert-btn button"
                    >
                      OK
                    </a> */}
                    <a
                      onClick={() => {
                        this.popupClose();
                        if (this.props.onClose) {
                          this.props.onClose();
                        }
                      }}
                      className="popup-alert-btn button"
                    >
                      OK
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </>
    );
  }
}

export default withNavigation(Commonalert);
